export default __webpack_public_path__ + "static/media/house-1.047057c8.jpg";